import React from 'react';
import PropTypes from 'prop-types';
import InvoiceErrorIcon from '../../../images/errores/boletas.svg';
import ErrorContainer from './styles/DetailLoadStyled';

const DetailLoad = ({ monthly }) => (
  <ErrorContainer className={monthly ? 'monthly' : ''}>
    <img src={InvoiceErrorIcon} alt="" />
    <div>
      <h3>
        NO PUDIMOS CARGAR
        <br />
        EL DETALLE DE TU BOLETA
      </h3>
      <p>
        En estos momentos nuestro servicio está presentando problemas. Porfavor,
        inténtalo más tarde.
      </p>
    </div>
  </ErrorContainer>
);

DetailLoad.propTypes = {
  monthly: PropTypes.bool,
};

DetailLoad.defaultProps = {
  monthly: false,
};

export default DetailLoad;
